<template>
  <BaseCard class="actionCard" :disabled="disabled" :true-value="trueValue" :value="value" :checkbox="checkbox" :clickable="clickable" :check-icon="checkIcon">
    <template v-slot:title>{{ obj.name }}</template>
    <template v-slot:subtitle>{{ actionSubType }}</template>
    <template v-slot:action>{{ actionType }}</template>
    <template v-if="obj.saves" v-slot:abilitySmall>{{ obj.saves.map((key) => skillList[key]?.ability || key).join(',') }}</template>
    <template v-if="obj.abilities" v-slot:ability>+{{ obj.abilities.join(',') }}</template>

    <Text>{{ description }}</Text>
    <template v-if="obj.requiresRested || obj.saves">
      <Tags>
        <span v-if="obj.requiresRested">Rested</span>
        <span v-for="skill in obj.saves" :key="skill">
          {{ skillList[skill].name }}
        </span>
      </Tags>
    </template>
  </BaseCard>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'

import BaseCard from '@/components/cards/BaseCard'
import Text from '@/components/cards/content/Text'
import Tags from '@/components/cards/content/Tags'

import cardProps from '@/helpers/cardProps'
import parseDescription from '@/helpers/parseDescription'

import skillList from '@/data/skills'
import actionList from '@/data/actions'
import featureList from '@/data/features'

export default defineComponent({
  props: {
    action: {
      type: String
    },

    feature: {
      type: String
    },

    ...cardProps
  },

  components: {
    Text,
    Tags,
    BaseCard
  },

  setup (props) {
    let obj
    if (props.action) {
      obj = computed(() => {
        return actionList[props.action]
      })
    } else {
      obj = computed(() => {
        return featureList[props.feature]
      })
    }
    
    const computedCharacter = inject('computedCharacter')
    const description = computed(() => parseDescription(computedCharacter, obj.value))

    const actionType = computed(() => {
      switch (obj.value.type) {
        case 'bonus':
          return 'Bonus Action'
        case 'reaction':
          return 'Reaction'
        case 'free':
          return 'Free Action'
        case 'spell':
          return 'See Spell'
      }
      return 'Action'
    })

    const actionSubType = computed(() => {
      let subtype = ''
      switch (obj.value.subtype) {
        case 'attack':
          subtype += 'Attack '
          break
        case 'move':
          subtype += 'Movement '
          break
      }
      subtype += 'Action'
      if (props.feature) subtype += ' (Feature)'
      return subtype
    })

    return {
      obj: obj,
      description,
      actionType,
      actionSubType,
      props,

      // Data
      skillList
    }
  }
})
</script>
